import { AbstractControl, ValidatorFn } from '@angular/forms';

export function checkSectorValidator(keyValue: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return control.value[keyValue] ? null : { sector_id: 'Не выбран сектор для перепривязки' };
  };
}

export const minLengthArray = (min: number) => {
  return (c: AbstractControl): { [key: string]: any } => {
    if (c.value.length >= min) {
      return null;
    }

    return {MinLengthArray: true};
  };
};
